/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Leveling_Faq_Start_AInputs */



/**
* | output |
* | --- |
* | "No. When you turn levelling on, every member's level is worked out from the activity already recorded, and nothing is announced for it." |
*
* @param {Products_Leveling_Faq_Start_AInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_leveling_faq_start_a = /** @type {((inputs?: Products_Leveling_Faq_Start_AInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Leveling_Faq_Start_AInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет. Когда вы включаете уровни, уровень каждого участника рассчитывается по уже записанной активности, и об этом ничего не объявляется.")
	return /** @type {LocalizedString} */ ("No. When you turn levelling on, every member's level is worked out from the activity already recorded, and nothing is announced for it.")
});